import { Fragment } from "react"

import {
  Text,
  Image,
  Flex,
  Box,
  UnorderedList,
  ListItem,
  Tr,
  Td,
  Show,
  useBreakpointValue,
} from "@chakra-ui/react"

import flightImages from "../../../flightImages"
import airplane from "../../../img/airplane.svg"
import {
  COLORS,
  DATE_FORMAT_EXPANDABLE_ROW,
} from "../../../constants/constants"
import { formatUTCDate } from "../../../helpers/functions"
import AddToTripBtn from "./AddToTripBtn"
import LayoverRow from "./LayoverRow"

const ExpandableRow = ({
  flight,
  userCarts,
  handleAddToTrip,
  isAddingToCart,
  canCreateFlightCart,
}) => {
  const colSpanValue = useBreakpointValue({ base: 3, lg: 5 })
  const colSpanValueSeats = useBreakpointValue({ base: 3, lg: 4 })

  return (
    <>
      {flight.details.map((detail, index, details) => {
        const planeImage =
          details.length >= 3
            ? flightImages("group_3_plus")
            : flightImages(details[index].aircraft_details.slice(0, 2))

        const addedToCart = userCarts.some(
          (cart) => cart.flight_id === flight.id
        )

        return (
          <Fragment key={index}>
            <Tr
              backgroundColor={COLORS.grey}
              boxShadow={"0px 15px 18px 0px rgba(20, 23, 37, 0.13)"}
              position={"relative"}
              zIndex={1}
            >
              <Td colSpan={colSpanValue} p={{ base: 1, lg: 2 }} border={0}>
                <Flex my={4} fontSize="sm" fontWeight="semibold">
                  <Flex alignItems="center" gap="10px" w="36px">
                    <Image
                      width="100%"
                      src={planeImage}
                      margin="0 auto"
                      position="relative"
                    />
                  </Flex>

                  <Image
                    src={airplane}
                    width="24px"
                    height="108px"
                    alt={`reward_flight_duration_between_${flight.origin.name}_and_${flight.destination.name}`}
                    alignSelf="center"
                    mr="2px"
                  />

                  <Box fontSize="12px" mr={1}>
                    <Text color={COLORS.secondary}>
                      {formatUTCDate(
                        detail.departure_date,
                        DATE_FORMAT_EXPANDABLE_ROW
                      )}
                    </Text>
                    <Text>{detail.from_airport}</Text>

                    <Flex alignItems={"center"} gap={3}>
                      <Text color={COLORS.secondary} my={5} fontSize={"xs"}>
                        {detail.flight_duration}
                      </Text>

                      <Text color={COLORS.secondary}>
                        {detail.aircraft_details?.split("(")[0] || ""}
                        {detail.aircraft_details && detail.equipment && " | "}
                        {detail.equipment || ""}
                      </Text>
                    </Flex>

                    <Text color={COLORS.secondary}>
                      {formatUTCDate(
                        detail.arrival_date,
                        DATE_FORMAT_EXPANDABLE_ROW
                      )}
                    </Text>
                    <Text>{detail.to_airport}</Text>
                  </Box>
                </Flex>
              </Td>
              <Show above="lg">
                <Td alignContent={"flex-start"} colSpan={1}>
                  {index === 0 && canCreateFlightCart && (
                    <AddToTripBtn
                      handleAddToTrip={handleAddToTrip}
                      isLoading={isAddingToCart}
                      addedToCart={addedToCart}
                      designatedClass="Business"
                      disabled={
                        addedToCart ||
                        isAddingToCart ||
                        !flight.class_details.some(
                          (classDetail) =>
                            classDetail.designated_class === "Business"
                        )
                      }
                    />
                  )}
                </Td>

                <Td alignContent={"flex-start"} colSpan={1}>
                  {index === 0 && canCreateFlightCart && (
                    <AddToTripBtn
                      handleAddToTrip={handleAddToTrip}
                      isLoading={isAddingToCart}
                      designatedClass="First"
                      disabled={
                        addedToCart ||
                        isAddingToCart ||
                        !flight.class_details.some(
                          (classDetail) =>
                            classDetail.designated_class === "First"
                        )
                      }
                    />
                  )}
                </Td>
              </Show>

              <Td colSpan={colSpanValueSeats} alignContent={"flex-start"}>
                <Flex direction="column" fontSize={"12px"}>
                  <Text color={COLORS.secondary}>Seats:</Text>
                  <UnorderedList ml={6}>
                    {flight.class_details.map((classDetail, idx) => (
                      <ListItem key={idx} color={COLORS.secondary}>
                        {classDetail.designated_class} Class{" "}
                        {classDetail.remaining_seats}
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Flex>
              </Td>
            </Tr>

            {index < details.length - 1 && <LayoverRow detail={detail} />}
          </Fragment>
        )
      })}
    </>
  )
}

export default ExpandableRow
